export function sortByDate(a?: Date | string, b?: Date | string) {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return 1;
  }

  if (!b) {
    return -1;
  }

  let dateA: Date;
  let dateB: Date;
  try {
    dateA = new Date(a);
    dateB = new Date(b);
  } catch {
    return 0; // If parsing fails, treat as equal
  }

  return dateB.getTime() - dateA.getTime();
}
